function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
  id: "sus-path-1",
  points: "0 0 23.2197 0 23.2197 24.9995 0 24.9995"
}));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(11.000000, 2.000000)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "sus-mask-2",
  fill: "white"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#sus-path-1"
})), /*#__PURE__*/React.createElement("path", {
  d: "M22.4997,0.0545 C22.4667,0.0525 21.6647,-0.0005 20.3747,-0.0005 C16.0587,-0.0005 5.6257,0.6235 1.9817,6.4025 C0.3657,8.9645 0.2657,12.1895 1.6677,16.0055 C3.6787,13.7365 6.5807,11.0935 10.7427,8.3815 C10.7517,8.3765 10.7597,8.3715 10.7687,8.3655 L10.7697,8.3655 C11.2707,8.0375 11.9417,8.1765 12.2757,8.6705 C2.9377,15.4285 0.4887,21.6105 0.0897,22.7935 C-0.0273,23.1415 -0.0303,23.5105 0.0827,23.8605 C0.3157,24.5845 0.8857,24.9995 1.6457,24.9995 C1.7237,24.9995 1.8017,24.9955 1.8807,24.9875 C2.9347,24.8745 3.7717,24.0295 3.8717,22.9765 C3.9537,22.1185 4.2307,20.6865 5.0967,18.8935 C5.9957,19.0425 7.1197,19.1685 8.3827,19.1685 L8.3847,19.1685 C13.7527,19.1685 22.8157,16.8105 23.2197,1.0025 L23.2197,0.8255 C23.2197,0.4185 22.9047,0.0825 22.4997,0.0545",
  fill: "#FEFEFE",
  mask: "url(#sus-mask-2)"
})));

var SvgSustainability = function SvgSustainability(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "45px",
    height: "28px",
    viewBox: "0 0 45 28",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSustainability, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/sustainability.df37f950.svg";
export { ForwardRef as ReactComponent };